import { FiatCurrency } from '__generated__/globalTypes';
import { useCurrentUserCurrencies } from 'hooks/useCurrentUserCurrencies';

import eurImg from './assets/eur.webp';
import gpbImg from './assets/gpb.webp';
import usdImg from './assets/usd.webp';

const currencyIcons = {
  [FiatCurrency.USD]: usdImg,
  [FiatCurrency.GBP]: gpbImg,
  [FiatCurrency.EUR]: eurImg,
};

export const FiatWalletIcon = () => {
  const { fiatCurrency } = useCurrentUserCurrencies();
  return <img src={currencyIcons[fiatCurrency]} alt={fiatCurrency} />;
};
